export default "__VITE_ASSET__CfJ5TwWP__"